<template>
  <div
    ref="wrapper"
    class="wrapper"
  >
    <svg
      ref="svg"
      v-resize="debounceOnResize"
    />
  </div>
</template>

<script>
import { PieChart } from '@/helpers/PieChart'
import debounce from '@/helpers/debounce'
import { seriesColors } from '@/helpers/chartColors'

export default {
  props: {
    data: Array,
  },
  watch: {
    data(newVal) {
      this.chart.update(newVal)
    },
  },
  mounted() {
    console.log('wrapper width:', this.$refs.wrapper.clientWidth)
    const width = this.$refs.wrapper.clientWidth
    const height = this.$refs.wrapper.clientHeight
    
    this.chart = new PieChart(this.$refs.svg, this.data, { width, height, colors: seriesColors, fillOpacity: 1 })
  },
  methods: {
    resize() {
      this.chart.resize(this.$refs.wrapper.clientWidth, this.$refs.wrapper.clientHeight)
    },
    debounceOnResize: debounce(function () {
      this.resize()
    }, 300),
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
  height: 100%;
}

svg {
  display: block;
}
</style>